/**
 * Drawer configuration schema.
 * Defines all navigation drawer sections and their items.
 *
 * @key Unique translation key for localization.
 * @icon Material Design icon name.
 * @path Target route path.
 */
export const drawerConfig = {
  operational: [
    {
      key: "channels",
      icon: "mdi-access-point-network",
      path: "/app",
    },
    {
      key: "validation",
      icon: "mdi-checkbox-marked-circle-outline",
      path: "/app/validation",
    },
  ],

  administrative: [
    {
      key: "locations",
      icon: "mdi-storefront-outline",
      path: "/app/locations",
    },
    {
      key: "instruments",
      icon: "mdi-desktop-classic",
      path: "/app/instruments",
    },
  ],

  about: [
    {
      key: "about",
      icon: "mdi-information-outline",
      path: "/app/about",
    },
  ],
};
